import React from "react";
interface props {
  className?: string;
  fill?: string;
}
function FacebookSvg({ className, fill }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      className={className}
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill={fill ? fill : "#fff"}
        d="M18.231 9.943a8.29 8.29 0 00-8.287-8.287 8.29 8.29 0 00-8.287 8.287c0 4.011 2.851 7.35 6.63 8.122v-5.636H6.629V9.943h1.658V7.872c0-1.6 1.3-2.9 2.9-2.9h2.072v2.485h-1.657a.831.831 0 00-.829.829v1.657h2.486v2.486h-2.486v5.76a8.286 8.286 0 007.458-8.246z"
        opacity="0.8"
      ></path>
    </svg>
  );
}

export default FacebookSvg;
